/* Bintel newsletter corner card. Settings come from data attributes on #bntl-cc (sections/bintel-corner-card.liquid). */
(function(){
function init(){
  var root = document.getElementById('bntl-cc');
  if (!root || root.getAttribute('data-ready')) return;
  root.setAttribute('data-ready', '1');

  var d = root.dataset;
  var design = d.designMode === 'true';
  var KEY = 'bntlCornerCard:';
  var DAY = 864e5;
  var mobile = window.matchMedia('(max-width: 640px)');
  var card = root.querySelector('.bcc-card');
  var form = root.querySelector('form');
  var input = form.querySelector('input[type=email]');
  var err = root.querySelector('.bcc-err');
  var email = '';
  var chatHost = null, chatBtn = null, chatRect = null;

  function ls(k, v){
    try {
      if (v === undefined) return localStorage.getItem(KEY + k);
      if (v === null) localStorage.removeItem(KEY + k); else localStorage.setItem(KEY + k, v);
    } catch (e) { return null; }
  }
  function ss(k, v){
    try {
      if (v === undefined) return sessionStorage.getItem(KEY + k);
      if (v === null) sessionStorage.removeItem(KEY + k); else sessionStorage.setItem(KEY + k, v);
    } catch (e) { return null; }
  }

  function state(){ return d.state; }
  function setState(s){
    d.state = s;
    var open = s !== 'hidden' && s !== 'min';
    document.documentElement.classList.toggle('bcc-sheet-open', open && mobile.matches);
    if (open && d.bg) {
      root.querySelector('.bcc-strip').style.backgroundImage = 'url("' + d.bg + '")';
      d.bg = '';
    }
    place();
    setTimeout(place, 500);
  }

  /* ---- Line up with the Shopify Inbox chat button ---- */
  function findChatButton(node){
    var all = node.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el.tagName === 'BUTTON' && el.hasAttribute('aria-expanded') && !el.closest('[role=dialog]')) return el;
      if (el.shadowRoot) { var hit = findChatButton(el.shadowRoot); if (hit) return hit; }
    }
    return null;
  }
  function watchChat(){
    if (!chatHost || chatHost.__bcc) return;
    chatHost.__bcc = true;
    new MutationObserver(function(){
      var open = chatHost.hasAttribute('open');
      root.classList.toggle('bcc-chat-open', open);
      if (open && /^(default|error|success)$/.test(state())) minimise(false);
    }).observe(chatHost, { attributes: true, attributeFilter: ['open'] });
  }
  function place(){
    if (!chatHost) chatHost = document.querySelector('shopify-chat');
    if (chatHost && chatHost.shadowRoot && (!chatBtn || !chatBtn.isConnected)) chatBtn = findChatButton(chatHost.shadowRoot);
    if (chatHost) watchChat();
    if (chatBtn) {
      var r = chatBtn.getBoundingClientRect();
      // Undo any lift we've applied to the chat so positions are always its resting spot.
      var t = getComputedStyle(chatHost).transform, ty = t && t !== 'none' ? new DOMMatrixReadOnly(t).m42 : 0;
      if (r.width > 0 && r.height > 0) chatRect = { l: r.left, r: r.right, t: r.top - ty, b: r.bottom - ty, h: r.height };
    }
    if (!chatRect) return;
    liftChat();
    var vw = document.documentElement.clientWidth, vh = window.innerHeight;
    var right = (chatRect.l + chatRect.r) / 2 > vw / 2;
    var s = root.style;
    d.side = right ? 'right' : 'left';
    s.setProperty('--bcc-edge', (right ? vw - chatRect.r : chatRect.l) + 'px');
    s.setProperty('--bcc-card-bottom', (vh - chatRect.t + 12) + 'px');
    s.setProperty('--bcc-mini-edge', ((right ? vw - chatRect.l : chatRect.r) + 8) + 'px');
    s.setProperty('--bcc-mini-bottom', (vh - chatRect.b) + 'px');
    s.setProperty('--bcc-mini-h', chatRect.h + 'px');
  }
  // On mobile the card is a bottom sheet, so lift the chat button to sit just above it.
  function liftChat(){
    if (!chatRect || !document.documentElement.classList.contains('bcc-sheet-open')) return;
    var lift = card.offsetHeight + 12 - (window.innerHeight - chatRect.b);
    document.documentElement.style.setProperty('--bcc-chat-lift', Math.max(0, lift) + 'px');
  }
  if (window.ResizeObserver) new ResizeObserver(liftChat).observe(card);

  // The chat button animates in, so keep measuring until its size settles.
  var polls = 0, lastRect = '';
  var poll = setInterval(function(){
    place();
    var now = JSON.stringify(chatRect);
    if ((chatRect && now === lastRect) || ++polls > 50) clearInterval(poll);
    lastRect = now;
  }, 600);
  window.addEventListener('resize', function(){ chatRect = null; place(); });

  /* ---- Actions ---- */
  function minimise(moveFocus){
    if (state() === 'success') { hide(); return; }
    setState('min');
    ss('state', 'min');
    if (moveFocus) root.querySelector('[data-bcc-expand]').focus();
  }
  function hide(){ setState('hidden'); ss('state', null); }
  function showError(msg){
    err.textContent = msg;
    setState('error');
    form.classList.remove('bcc-shake'); void form.offsetWidth; form.classList.add('bcc-shake');
    input.setAttribute('aria-invalid', 'true');
    input.focus();
  }

  function klaviyo(path, attributes){
    if (!d.klaviyoCompany) return Promise.resolve(false);
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(d.klaviyoCompany), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify(attributes)
    }).then(function(res){ return res.ok; });
  }
  function subscribeKlaviyo(addr){
    if (!d.klaviyoList) return Promise.resolve(false);
    return klaviyo('subscriptions', { data: {
      type: 'subscription',
      attributes: {
        custom_source: d.source || 'Corner card popup',
        profile: { data: { type: 'profile', attributes: {
          email: addr,
          properties: { 'Popup Source': 'Corner card', 'Popup Code': d.code }
        } } }
      },
      relationships: { list: { data: { type: 'list', id: d.klaviyoList } } }
    } });
  }
  // The Shopify customer record is what makes the segment-restricted discount code work at checkout.
  // Shopify's captcha script replaces form.submit() with a version that adds the hCaptcha token, so wait
  // for it to bind (focusing the field triggers that) before posting. The page returns with ?customer_posted=true.
  function submitToShopify(){
    var tries = 0;
    (function go(){
      if (form.submit !== HTMLFormElement.prototype.submit || tries++ > 30) return form.submit();
      if (tries === 1) input.dispatchEvent(new FocusEvent('focusin', { bubbles: true }));
      setTimeout(go, 100);
    })();
  }
  function applyDiscount(){
    if (d.autoApply !== 'true' || !d.code) return;
    fetch('/discount/' + encodeURIComponent(d.code) + '?redirect=%2Fcart.js', { credentials: 'same-origin' }).catch(function(){});
  }
  function complete(){
    ls('subscribed', '1');
    ls('dismissed', null);
    ss('state', null);
    ss('pending', null);
    applyDiscount();
    var hadFocus = card.contains(document.activeElement);
    setState('success');
    if (hadFocus) root.querySelector('.bcc-ok-view .bcc-h').focus();
  }

  form.addEventListener('submit', function(e){
    e.preventDefault();
    e.stopImmediatePropagation();
    if (state() === 'loading') return;
    var value = input.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value)) return showError(d.errInvalid);
    email = input.value = value;
    input.removeAttribute('aria-invalid');
    err.textContent = '';
    ss('pending', value);
    setState('loading');
    var timeout = new Promise(function(resolve){ setTimeout(resolve, 2500); });
    Promise.race([subscribeKlaviyo(value).catch(function(){}), timeout]).then(submitToShopify);
  });
  input.addEventListener('input', function(){
    if (state() === 'error') { setState('default'); input.removeAttribute('aria-invalid'); }
  });

  root.addEventListener('click', function(e){
    var t = e.target.closest('button');
    if (!t) return;
    if (t.hasAttribute('data-bcc-min')) minimise(true);
    else if (t.hasAttribute('data-bcc-expand')) { ss('state', null); setState('default'); input.focus(); }
    else if (t.hasAttribute('data-bcc-dismiss')) { if (!design) ls('dismissed', String(Date.now())); hide(); }
    else if (t.hasAttribute('data-bcc-copy')) {
      var done = function(){ t.textContent = 'Copied ✓'; };
      if (navigator.clipboard) navigator.clipboard.writeText(d.code).then(done, function(){});
    }
    else if (t.classList.contains('bcc-chip')) {
      root.querySelectorAll('.bcc-chip').forEach(function(c){ c.setAttribute('aria-pressed', String(c === t)); });
      root.querySelector('.bcc-thanks').textContent = d.thanks;
      if (email) klaviyo('profiles', { data: { type: 'profile', attributes: {
        email: email, properties: { 'Popup Interest': t.getAttribute('data-value') }
      } } }).catch(function(){});
    }
  });
  card.addEventListener('keydown', function(e){ if (e.key === 'Escape') minimise(true); });

  /* ---- When to show ---- */
  function schedule(){
    var fired = false, timer;
    var pct = Number(d.scroll) || 0;
    function fire(){
      if (fired) return;
      fired = true;
      clearTimeout(timer);
      window.removeEventListener('scroll', onScroll);
      setState('default');
    }
    function onScroll(){
      var max = document.documentElement.scrollHeight - window.innerHeight;
      if (max > 0 && (window.scrollY / max) * 100 >= pct) fire();
    }
    timer = setTimeout(fire, (Number(d.delay) || 0) * 1000);
    if (pct > 0) window.addEventListener('scroll', onScroll, { passive: true });
  }

  var params = new URLSearchParams(location.search);
  if (params.has('_kx')) ls('subscribed', '1');
  if (/email/i.test(params.get('utm_medium') || '')) ls('dismissed', String(Date.now()));

  if (design) { setState('default'); return; }
  if (ss('pending') && params.get('customer_posted') === 'true') { email = ss('pending'); complete(); return; }
  if (ls('subscribed')) return;
  var dismissed = Number(ls('dismissed'));
  if (dismissed && Date.now() - dismissed < (Number(d.cooldown) || 14) * DAY) return;
  if (ss('state') === 'min') setState('min'); else schedule();
}
init();
document.addEventListener('shopify:section:load', init);
})();